<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13,0.9999999403953552C13,0.9999999403953552,6,0.9999999403953552,6,0.9999999403953552C3.8,0.9999999403953552,2,2.799999940395355,2,4.999999940395355C2,7.199999940395355,3.8,8.999999940395355,6,8.999999940395355C6,8.999999940395355,6,13.999999940395355,6,13.999999940395355C6,14.599999940395355,6.4,14.999999940395355,7,14.999999940395355C7.6,14.999999940395355,8,14.499999940395355,8,13.999999940395355C8,13.999999940395355,8,2.9999999403953552,8,2.9999999403953552C8,2.9999999403953552,10,2.9999999403953552,10,2.9999999403953552C10,2.9999999403953552,10,13.999999940395355,10,13.999999940395355C10,14.599999940395355,10.4,14.999999940395355,11,14.999999940395355C11.6,14.999999940395355,12,14.499999940395355,12,13.999999940395355C12,13.999999940395355,12,2.9999999403953552,12,2.9999999403953552C12,2.9999999403953552,13,2.9999999403953552,13,2.9999999403953552C13.5,2.9999999403953552,14,2.5999999403953553,14,1.9999999403953552C14,1.3999999403953551,13.6,0.9999999403953552,13,0.9999999403953552C13,0.9999999403953552,13,0.9999999403953552,13,0.9999999403953552Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Paragraph',
} as DefineComponent
</script>
